// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","menu":"styles_menu__p8EPz","menu__icon":"styles_menu__icon__wE7UE","menu__link":"styles_menu__link__czuRh","fresh":"styles_fresh__iEnMf"};